import React, { useEffect, useState } from 'react';

import Chart from "react-apexcharts";

function GroupedBarHubspotCard({
  data,
  height
}) {

  const [ options, setOptions ] = useState({})

  useEffect(() => {
    if(data!=null && data!={} && 'categories' in data) {
      setOptions({chart: {
          type: 'bar',
          height: 430,
          toolbar: {
            show: true,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
              customIcons: []
            }
          }
        },
        legend: {
          position: "top"
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          },
          formatter: function (val, opt) {
            return val+'%'
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        tooltip: {
          enabled: false
        },
        xaxis: {
          categories: data.categories,
        }
      })
    }
  }, [data]);

  return (
      <div className="flex-grow bg-white h-5/6 overflow-y-scroll shadow-1 rounded-sm border
      border-gray-200 p-3 divide-y divide-slate-200 m-auto my-5" >
        {options !== {} && 'series' in data && data.series.length>0 ?
            <Chart
              options={options}
              type="bar"
              height={height}
              series={data.series}/> : ''}
      </div>
  );
}

export default GroupedBarHubspotCard;
